import { Component } from '@angular/core';
import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { ProductCardComponent } from '../../../components/product-card/product-card.component';
import { RouterOutlet } from '@angular/router';
import { CategoryPageAbstract } from '../../common/category-page.abstract';
import { ObserverDirective } from 'src/app/shared/directives/observer/observer.directive';
import { ScrollListDirective } from 'src/app/shared/directives/scroll-list/scroll-list.directive';
import { ScrollItemDirective } from 'src/app/shared/directives/scroll-list/scroll-item.directive';

@Component({
  selector: 'app-default-category-page',
  templateUrl: './default-category-page.component.html',
  styleUrls: ['./default-category-page.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    AsyncPipe,
    RouterOutlet,
    ProductCardComponent,
    ObserverDirective,
    ScrollListDirective,
    ScrollItemDirective
  ]
})
export class DefaultCategoryPageComponent extends CategoryPageAbstract { }
